import {FuseRouteItemType} from '@/@fuse/utils/FuseUtils';
import {AUTH_ROLES} from '@/app/auth';

import CreateJourneyPage from './CreateJourneyPage';

const CreateJourneyRoute: FuseRouteItemType = {
  path: '',
  element: <CreateJourneyPage />,
  auth: AUTH_ROLES.parent,
};

export default CreateJourneyRoute;
